import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/dashboard');
  };
  return <main className="min-h-screen w-full flex items-center justify-center" style={{
    backgroundColor: '#eff0f2',
    fontFamily: 'Roboto, sans-serif'
  }} data-id="element-1484">
      {/* Centered Card */}
      <div className="bg-white w-full" style={{
      maxWidth: '380px',
      boxShadow: 'none',
      border: '1px solid #E4E4E4',
      borderRadius: '8px',
      padding: '40px 24px 36px'
    }} data-id="element-1485">
        {/* Logo */}
        <div className="flex justify-center mb-8" data-id="element-1486">
          <img src="https://dev.bandiperchicrea.it/images/logo_dark.svg" alt="Per Chi Crea" style={{
          height: '72px',
          width: 'auto'
        }} data-id="element-1487" />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} data-id="element-1488">
          {/* Email Field */}
          <div className="mb-4" data-id="element-1489">
            <label htmlFor="email" className="block mb-1 text-[#293B54]" style={{
            fontSize: '14px'
          }} data-id="element-1490">
              Email
            </label>
            <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full outline-none transition-colors" style={{
            height: '40px',
            padding: '0 10px',
            border: '1px solid #E4E4E4',
            borderRadius: '9999px',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif'
          }} onFocus={e => e.target.style.borderColor = '#2A97DF'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1491" />
          </div>

          {/* Password Field */}
          <div className="mb-3" data-id="element-1492">
            <label htmlFor="password" className="block mb-1 text-[#293B54]" style={{
            fontSize: '14px'
          }} data-id="element-1493">
              Password
            </label>
            <div className="relative" data-id="element-1494">
              <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="w-full outline-none transition-colors" style={{
              height: '40px',
              padding: '0 36px 0 10px',
              border: '1px solid #E4E4E4',
              borderRadius: '9999px',
              fontSize: '14px',
              fontFamily: 'Roboto, sans-serif'
            }} onFocus={e => e.target.style.borderColor = '#2A97DF'} onBlur={e => e.target.style.borderColor = '#E4E4E4'} data-id="element-1495" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-2 top-1/2 -translate-y-1/2 transition-colors" style={{
              color: '#AAAAAA'
            }} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'} data-id="element-1496">
                {showPassword ? <Icon icon="tabler:eye" fontSize={18} data-id="element-1497" /> : <Icon icon="tabler:eye-off" fontSize={18} data-id="element-1498" />}
              </button>
            </div>
          </div>

          {/* Forgot Password */}
          <div className="mb-5" data-id="element-1499">
            <a href="#" className="hover:underline text-[#293B54]" style={{
            fontSize: '13px'
          }} data-id="element-1500">
              Password dimenticata?
            </a>
          </div>

          {/* Login Button */}
          <button type="submit" className="w-full transition-colors hover:opacity-90" style={{
          height: '44px',
          backgroundColor: '#293B54',
          color: '#FFFFFF',
          borderRadius: '9999px',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          border: 'none',
          cursor: 'pointer'
        }} data-id="element-1501">
            Login
          </button>

          {/* No registrations notice */}
          <p className="text-center mt-[20px] mb-[20px] text-[14px]" style={{
          color: '#293B54',
          lineHeight: '1.5',
          marginLeft: 0,
          marginRight: 0,
          paddingLeft: 0,
          paddingRight: 0
        }} data-id="element-1502">
            Al momento non sono ammesse nuove registrazioni
          </p>

          {/* Manual section */}
          <p className="text-center mt-5" style={{
          fontSize: '14px',
          color: '#293B54',
          fontWeight: 500,
          lineHeight: '1.5'
        }} data-id="element-1503">
            Per consultare il manuale di utilizzo della piattaforma
          </p>

          {/* CLICCA QUI button */}
          <button type="button" className="w-full mt-3 transition-colors hover:bg-[#293B54] hover:text-white" style={{
          height: '44px',
          backgroundColor: 'transparent',
          color: '#293B54',
          borderRadius: '9999px',
          border: '1px solid #293B54',
          fontFamily: 'Roboto Condensed, sans-serif',
          fontSize: '14px',
          fontWeight: 400,
          cursor: 'pointer'
        }} data-id="element-1504">
            Clicca qui
          </button>
        </form>
      </div>

      {/* INVIA SEGNALAZIONE - fixed bottom right */}
      <div className="fixed bottom-0 right-0" style={{
      zIndex: 50
    }} data-id="element-1505">
        <button type="button" className="transition-colors hover:bg-gray-50" style={{
        padding: '8px 16px',
        backgroundColor: '#FFFFFF',
        color: '#293B54',
        border: '1px solid #E4E4E4',
        borderRadius: '8px',
        fontFamily: 'Roboto Condensed, sans-serif',
        fontSize: '14px',
        fontWeight: 400,
        cursor: 'pointer'
      }} data-id="element-1506">
          Invia segnalazione
        </button>
      </div>
    </main>;
}